import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import OrganisationResultsContext from './context';
import Keywords from '../common/components/keywords';
import useGetKeywordsUsedByOrganisation from '../../../services/keywords/keywords-used-by-organisation-service';

export default function TopKeywords({ organisation }) {
  const { dispatch } = React.useContext(OrganisationResultsContext);
  const [{ data }, executeQuery] = useGetKeywordsUsedByOrganisation(organisation, 5);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  React.useEffect(() => {
    if (_.get(data, 'keywords.length')) {
      dispatch({ type: 'setKeywords', payload: data.keywords });
    }
  }, [data, dispatch]);

  const props = { data, relation: 'assigned by', query: organisation };
  return <Keywords {...props} />;
}

TopKeywords.propTypes = {
  organisation: PropTypes.string.isRequired,
};
